import { makeStyles } from '@material-ui/core/styles';
import fonts from 'src/constants/fonts';
import { imageRatio, portraitImageRatio } from 'src/constants/stylesheet';

export default makeStyles(
  () => ({
    root: {
      position: 'relative',
    },
    // The aspect box. Split out from root so an optional caption can sit
    // below it instead of being absolutely positioned inside it.
    frame: {
      position: 'relative',
      height: 0,
      paddingBottom: `${imageRatio}%`,
      overflow: 'hidden',

      '[data-orientation="portrait"] &': {
        paddingBottom: `${portraitImageRatio}%`,
      },
    },
    inner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,

      opacity: 0,
      transform: 'translateY(50px)',
      transition: '.3s opacity ease, .3s transform ease',

      '[data-show="true"] &': {
        opacity: 1,
        transform: 'translateY(0px)',
      },
    },
    title: {
      position: 'absolute',
      top: 0,
      left: 0,

      ...fonts.DTNobelCondBold,
      textTransform: 'uppercase',
      zIndex: 1,
      transition: 'opacity .3s ease-in-out',

      '[data-touch-device="false"] $root &': {
        opacity: 0,
      },
      '[data-touch-device="false"] $root:hover &': {
        opacity: 1,
      },

      // Trailing space so the white label doesn't stop hard at the last
      // letter. `clone` repeats the padding on every wrapped line instead of
      // only the last, so the name and the function both get it.
      '& > span': {
        backgroundColor: 'white',
        paddingRight: '0.35em',
        WebkitBoxDecorationBreak: 'clone',
        boxDecorationBreak: 'clone',
      },
    },
    // The function keeps the title's type and stacking, but is set as written
    // rather than upper-cased, so it reads as a description not a second name.
    titleRole: {
      textTransform: 'none',
    },
    figure: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,

      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
      },

      // Upright photos are cropped top and bottom to reach the cell shape;
      // anchor to the top so heads survive and the trim comes off the feet.
      '[data-orientation="portrait"] & img': {
        objectPosition: 'center top',
      },
    },
    link: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  }),
  { name: 'PreviewItem' }
);
